import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PRM } from '@reflact/prmacweb';
import { KcBackendService } from '../konva-canvas/kc-backend.service';
import { PackService } from '../services/PackService';
import { PdfAnnotationService } from '../services/PdfAnnotationService';
import { PageContext } from './PageAnnotationResolver';

type introductionView = {
  selectedDocObject: PRM.Document;
  pageContexts: {
    page: number,
    docid: string,
    timeblockid: string,
    participantid: string
  }[];
  konvaJsons: any[];
  annotations: any[];
  pack: PRM.IpadPackage;
}

export const introductionViewResolver: ResolveFn<introductionView> = async (route) => {
  const packService = inject(PackService);
  const kcService = inject(KcBackendService);
  const pageAnnotationService = inject(PdfAnnotationService);

  const data = {
    selectedDocObject: undefined,
    pageContexts: [],
    konvaJsons: [],
    annotations: [],
    pack: await packService.getCurrentPackage()
  }

  data.selectedDocObject = data.pack.introDocs.find(doc => doc._id === route.params.selecteddoc);
  const pageContext: PageContext = {
    page: 0,
    docid: data.selectedDocObject._id,
    timeblockid: "introduction",
    participantid: "-1"
  }
  if (pageContext.docid != null) {
    const availableJsonPages: any = await kcService.getAvailableJsonOverlayPageNumbers(pageContext);
    const availableAnnotationPages: any = await pageAnnotationService.getAvailableAnnotationTextPageNumbers(pageContext.docid, pageContext.timeblockid, pageContext.participantid);
    for (let i = 0; i < data.selectedDocObject.metadata.pagescount; i++) {
      pageContext.page = i
      data.pageContexts.push({
        page: i,
        docid: pageContext.docid,
        timeblockid: "introduction",
        participantid: "-1"
      });
      if (availableJsonPages.indexOf(i.toString()) > -1) {
        const konvaJson: any = await kcService.loadJson(pageContext);
        data.konvaJsons.push(konvaJson);
      } else {
        data.konvaJsons.push({});
      }
      if (availableAnnotationPages.indexOf(i.toString()) > -1) {
        const annotationresult: any = await pageAnnotationService.getAnnotationText(pageContext.docid, i, pageContext.timeblockid, pageContext.participantid);
        data.annotations.push(annotationresult.value);
      } else {
        data.annotations.push('');
      }
    }
  }

  return data;
};